import { ChangeDetectorRef, Inject, Optional, Pipe, PipeTransform } from '@angular/core';


import { TRANSLOCO_SCOPE, TranslocoPipe, TranslocoScope, TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'translate',
  pure: false, // keep reactivity
  standalone: true
})
export class TranslatePipe implements PipeTransform {
  private innerPipe: TranslocoPipe;

  constructor(
    translocoService: TranslocoService,
    @Optional() @Inject(TRANSLOCO_SCOPE) providerScope: TranslocoScope | TranslocoScope[] | undefined,
    @Optional() @Inject('TRANSLOCO_LANG') providerLang: string | undefined, // if your app provides it
    cdr: ChangeDetectorRef
  ) {
    this.innerPipe = new TranslocoPipe(translocoService, providerScope, providerLang, cdr);
  }

  transform(key: string, params?: Record<string, any>): string {
    return this.innerPipe.transform(key, params);
  }
}
